// extracted by mini-css-extract-plugin
module.exports = {"heroHeading":"hero-heading_heroHeading__0_gkw","title":"hero-heading_title__0WuyU","description":"hero-heading_description__43RmG"};